import { defineStore } from 'pinia';
import { diacriticLanguageNames } from '@/helpers/languages/languageNames.js';

export const useTranslationsStore = defineStore('translations', {
  state: () => ({
    languages: window.trualtaGlobalData.LOCALE_OPTIONS,
    currentLang: window.trualtaGlobalData.CURRENT_LOCALE_NAME,
    translations: JSON.parse(window.trualtaGlobalData.TRANSLATIONS) || {},
    preferredLocale: window.trualtaGlobalData.USER_PREFERRED_LOCALE,
    diacriticLanguageNames: diacriticLanguageNames,
  }),
  actions: {
    /**
     * Translates a given text with optional parameter replacements.
     *
     * @param {string} text - The text to be translated.
     * @param {Object} [params={}] - An object with keys representing parameter placeholders and their respective replacement values.
     * @return {string} - The translated text, with parameters replaced if applicable, or the original text if no translation is found.
     */
    translate(text, params = {}) {
      if (this.translations !== undefined && this.translations[text]) {
        let translatedText = this.translations[text];

        // Replace parameters in the format :key with their respective values
        Object.keys(params).forEach((key) => {
          translatedText = translatedText.replace(`:${key}`, params[key]);
        });

        return translatedText;
      }

      return text;
    },
  },
  getters: {
    currentLanguageFullName(state) {
      return state.languages[state.currentLang];
    },
    findLanguageByLocale(state) {
      return (locale) => state.diacriticLanguageNames[locale];
    },
  },
});
